<template lang="pug">
  v-tooltip(bottom v-if="visible")
    span.error--text(slot="activator")  {{extra.name}}({{extra.options.kind}})&#32;
    span {{extra}}

</template>

<script>
export default {
  props: ['extra'],
  computed: {
    visible() {
      return this.dev && this.extra.name !== 'Menu'
    },
    dev() {
      return !/\./.test(window.location.host)
    }
  }
}
</script>
